import {
    AdapterRegistry,
    type ITridentResource,
    Metamodel,
    ModelConstants,
    NamedAsyncAdapter,
    PbiDataflow
} from 'shell-models-lib';

// Keep in sync with trident-iframemetadata-client.ts
interface IPbiDataflow {
    id: string;
    name: string;
    objectId: string;
    workspaceObjectId: string;
    version?: string;
    properties: {
        type: string;
        typeProperties: {
            workspace: string;
            parametric?: boolean;
        };
    };
}

@AdapterRegistry.adapter({
    model: Metamodel.modelFor(PbiDataflow),
    asynchronous: true
})
export class PbiDataflowAdapter extends NamedAsyncAdapter<PbiDataflow, IPbiDataflow> {
    protected async _toResource(dataflow: PbiDataflow): Promise<IPbiDataflow> {
        // We will never care about converting this model to a resource
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        return {} as IPbiDataflow;
    }

    protected async _toModel(resource: IPbiDataflow, model?: PbiDataflow): Promise<PbiDataflow> {
        model.objectId = model.dataflowId = resource.objectId;
        model.displayName = resource.name;
        model.workspaceId = resource?.properties?.typeProperties.workspace;
        model.version = resource.version
        model.isParametric = resource.properties?.typeProperties.parametric;
        return model;
    }

    protected override async _toAzureResource(tridentResource: ITridentResource): Promise<IPbiDataflow> {
        return {
            id: `/subscriptions/xxxxxxxxx/resourceGroups/xxxx/providers/Microsoft.DataFactory/factories/xxxxxxx/dataflows/${tridentResource.displayName}`,
            name: tridentResource.displayName,
            objectId: tridentResource.objectId,
            workspaceObjectId: tridentResource.workspaceObjectId,
            version: tridentResource.version,
            properties: {
                type: ModelConstants.pbiDataflow,
                typeProperties: {
                    workspace: tridentResource.workspaceObjectId,
                    parametric: !!tridentResource.extendedProperties?.isParametric || undefined
                }
            }
        };
    }
}
